/* GTL4Life: the video strip under the delivery timeline (snippets/gtl-people-videos.liquid).
   Slider: the theme's own Splide (loaded by the theme on every page) in loop mode, 3 cards per view.
   Desktop: a muted 480p clip plays in a card while the pointer is over it.
   Click / tap: one shared player (<dialog>) with sound; it is built and its video loaded only on the first open. */
(function () {
  if (!window.customElements || customElements.get('gtl-people-videos')) return;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var ICON = {
    close: '<svg viewBox="0 0 24 24" width="18" height="18"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>',
    prev: '<svg viewBox="0 0 24 24" width="18" height="18"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg viewBox="0 0 24 24" width="18" height="18"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };
  var PLAYER_CSS =
    'html.gtl-pv-lock{overflow:hidden}' +
    '.gtl-pv-player{position:fixed;inset:0;width:100%;height:100%;max-width:none;max-height:none;margin:0;padding:0;border:0;background:transparent;overflow:hidden}' +
    '.gtl-pv-player::backdrop{background:rgba(0,0,0,.92)}' +
    '.gtl-pv-player__stage{position:relative;width:100%;height:100%;display:flex;align-items:center;justify-content:center}' +
    '.gtl-pv-player__video{display:block;height:88vh;height:88dvh;max-width:100vw;aspect-ratio:9/16;background:#000;border-radius:12px;object-fit:contain}' +
    '.gtl-pv-player__btn{position:absolute;z-index:2;width:42px;height:42px;display:flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:50%;cursor:pointer;color:#111;background:rgba(255,255,255,.92);box-shadow:0 1px 8px rgba(0,0,0,.3)}' +
    '.gtl-pv-player__close{top:calc(14px + env(safe-area-inset-top,0px));right:14px}' +
    '.gtl-pv-player__prev,.gtl-pv-player__next{top:50%;margin-top:-21px}' +
    '.gtl-pv-player__prev{left:10px;left:max(10px,calc(50% - 44vh * 9 / 16 - 62px));left:max(10px,calc(50% - 44dvh * 9 / 16 - 62px))}' +
    '.gtl-pv-player__next{right:10px;right:max(10px,calc(50% - 44vh * 9 / 16 - 62px));right:max(10px,calc(50% - 44dvh * 9 / 16 - 62px))}' +
    '.gtl-pv-player__count{position:absolute;z-index:2;top:calc(24px + env(safe-area-inset-top,0px));left:18px;color:#fff;font-size:14px;font-weight:600;text-shadow:0 1px 4px rgba(0,0,0,.6)}' +
    '@media (max-width:749px){.gtl-pv-player__video{width:100%;height:100%;border-radius:0}' +
    '.gtl-pv-player__prev{left:10px}.gtl-pv-player__next{right:10px}' +
    '.gtl-pv-player__btn{width:38px;height:38px;background:rgba(255,255,255,.8)}}';

  var player = null;

  function getPlayer() {
    if (player) return player;
    var d = document.createElement('dialog');
    d.className = 'gtl-pv-player';
    d.setAttribute('aria-label', 'Видео');
    d.innerHTML =
      '<style>' + PLAYER_CSS + '</style>' +
      '<div class="gtl-pv-player__stage">' +
      '<video class="gtl-pv-player__video" playsinline controls controlslist="nodownload noplaybackrate" disablepictureinpicture preload="auto"></video>' +
      '<span class="gtl-pv-player__count"></span>' +
      '<button type="button" class="gtl-pv-player__btn gtl-pv-player__close" aria-label="Затвори">' + ICON.close + '</button>' +
      '<button type="button" class="gtl-pv-player__btn gtl-pv-player__prev" aria-label="Предишно видео">' + ICON.prev + '</button>' +
      '<button type="button" class="gtl-pv-player__btn gtl-pv-player__next" aria-label="Следващо видео">' + ICON.next + '</button>' +
      '</div>';
    document.body.appendChild(d);
    var p = { dialog: d, video: d.querySelector('video'), count: d.querySelector('.gtl-pv-player__count'), list: [], index: 0 };
    var stage = d.querySelector('.gtl-pv-player__stage');

    d.querySelector('.gtl-pv-player__close').addEventListener('click', function () { d.close(); });
    d.querySelector('.gtl-pv-player__prev').addEventListener('click', function () { show(p.index - 1); });
    d.querySelector('.gtl-pv-player__next').addEventListener('click', function () { show(p.index + 1); });
    stage.addEventListener('click', function (e) { if (e.target === stage) d.close(); });
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(p.index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(p.index + 1); }
    });
    p.video.addEventListener('ended', function () { show(p.index + 1); });
    d.addEventListener('close', function () {
      p.video.pause();
      p.video.removeAttribute('src');
      p.video.load();
      document.documentElement.classList.remove('gtl-pv-lock');
    });

    // swipe left / right on phones (not over the native controls at the bottom)
    var touch = null;
    stage.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      touch = t.clientY < window.innerHeight - 90 ? { x: t.clientX, y: t.clientY } : null;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!touch) return;
      var t = e.changedTouches[0], dx = t.clientX - touch.x, dy = t.clientY - touch.y;
      touch = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(p.index + (dx < 0 ? 1 : -1));
    }, { passive: true });

    player = p;
    return p;
  }

  function show(i) {
    var p = player, n = p.list.length;
    p.index = ((i % n) + n) % n;
    var item = p.list[p.index], v = p.video;
    // 1080p only on a computer with a tall screen; phones get 720p
    var saveData = navigator.connection && navigator.connection.saveData;
    var tall = window.innerHeight * 0.88 * (window.devicePixelRatio || 1) > 1000;
    v.poster = item.poster || '';
    v.src = canHover.matches && tall && !saveData && item.hd ? item.hd : item.src;
    v.muted = false;
    var playing = v.play();
    if (playing && playing.catch) playing.catch(function () { v.muted = true; v.play().catch(function () {}); });
    p.count.textContent = (p.index + 1) + ' / ' + n;
    p.dialog.setAttribute('aria-label', item.label || 'Видео');
  }

  function whenSplide(cb, tries) {
    if (window.Splide) return cb();
    if ((tries || 0) > 60) return; // no slider: the strip stays a plain swipeable row
    setTimeout(function () { whenSplide(cb, (tries || 0) + 1); }, 100);
  }

  class GtlPeopleVideos extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = '1';
      var self = this;
      this.list = Array.prototype.map.call(this.querySelectorAll('.gtl-pv__card'), function (c) {
        return { src: c.dataset.src, hd: c.dataset.srcHd, poster: c.dataset.poster, label: c.getAttribute('aria-label') };
      });

      this.addEventListener('click', function (e) {
        var card = e.target.closest('.gtl-pv__card');
        if (!card) return;
        if (self.hovered) self.stopPreview(self.hovered);
        var p = getPlayer();
        p.list = self.list;
        show(parseInt(card.dataset.index, 10) || 0);
        if (!p.dialog.open) p.dialog.showModal();
        document.documentElement.classList.add('gtl-pv-lock');
      });

      if (canHover.matches) {
        this.addEventListener('pointerover', function (e) {
          var card = e.target.closest('.gtl-pv__card');
          if (card && card !== self.hovered) self.startPreview(card);
        });
        this.addEventListener('pointerout', function (e) {
          var card = e.target.closest('.gtl-pv__card');
          if (card && !card.contains(e.relatedTarget)) self.stopPreview(card);
        });
      }

      whenSplide(function () { self.mountSlider(); });
    }

    mountSlider() {
      var root = this.querySelector('.splide');
      if (!root || this.list.length < 2) return;
      this.classList.add('is-ready');
      try {
        new window.Splide(root, {
          type: this.list.length > 3 ? 'loop' : 'slide',
          perPage: 3,
          perMove: 1,
          gap: 10,
          padding: { left: 0, right: '16%' },
          arrows: this.list.length > 3,
          pagination: false,
          drag: true,
          speed: 450,
          easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
          i18n: { prev: 'Предишно видео', next: 'Следващо видео', slideX: 'Към видео %s', carousel: 'видеа', slide: 'видео' },
          breakpoints: { 749: { gap: 8, padding: 0 } }
        }).mount();
      } catch (err) {
        this.classList.remove('is-ready');
      }
    }

    startPreview(card) {
      if (this.hovered) this.stopPreview(this.hovered);
      this.hovered = card;
      var v = card.querySelector('video');
      if (!v) {
        v = document.createElement('video');
        v.muted = true;
        v.defaultMuted = true;
        v.loop = true;
        v.playsInline = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('aria-hidden', 'true');
        v.preload = 'auto';
        v.src = card.dataset.preview;
        v.addEventListener('playing', function () { if (card.isConnected && card.matches(':hover')) card.classList.add('is-previewing'); });
        card.insertBefore(v, card.querySelector('.gtl-pv__play'));
      }
      var playing = v.play();
      if (playing && playing.catch) playing.catch(function () {});
    }

    stopPreview(card) {
      if (this.hovered === card) this.hovered = null;
      card.classList.remove('is-previewing');
      var v = card.querySelector('video');
      if (v) {
        v.pause();
        try { v.currentTime = 0; } catch (e) {}
      }
    }
  }

  customElements.define('gtl-people-videos', GtlPeopleVideos);
})();
